import { render, staticRenderFns } from "./PwaActionBar.vue?vue&type=template&id=3118142a"
import script from "./PwaActionBar.vue?vue&type=script&lang=js"
export * from "./PwaActionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports